import React, { useEffect, useState } from "react";
import Body from "src/components/common/Body";
import Accordion from "src/components/common/Accordion";
import styled from "styled-components";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import RejectionBox from "src/components/as/RejectionBox";
import RejectionReason from "src/components/as/RejectionReason";
import { useEstimateApproveMutation, useEstimateDetailQuery, useEstimateRejectMutation } from "src/api/estimateAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import { EstimateVo } from "src/vo/estimateVo";
import { useAppSelector } from "src/store/actions/action";
import { shallowEqual } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { addCommas } from "src/utils/addCommas";
import moment from "moment";
import { isEmpty } from "lodash";
import queryString from "query-string";
import { useAsDetailQuery } from "src/api/asAPI";
import ErrorParser from "src/utils/jsonParser";

const estimateDetail = () => {
  const [init, setInit] = useState({
    apiSkip: true,
    asDetailApiSkip: true,
  });
  const { apiSkip, asDetailApiSkip } = init;

  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParser = queryString.parse(search);
  const rnData = queryParser["rn"];

  const es_idx: any = getPathValue();

  // 초기 세팅
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);

  const [state, setState] = useState({
    isRejectBox: false,
  });
  const { isRejectBox } = state;

  const [estimate, setEstimate] = useState<EstimateVo>({});
  const [deleteYn, setDeleteYn] = useState<string>();

  const [freeYn, setFreeYn] = useState<string>();

  const { company_id, company_name, estimate_goods_list, as_idx, approval_code, total_price, cancel_reason, insert_date, free_yn } = estimate;

  // API
  const asDetail = useAsDetailQuery(as_idx, { skip: asDetailApiSkip });
  const esDetail = useEstimateDetailQuery(es_idx, { skip: apiSkip });
  const [esApproveUpdate, { isLoading, isSuccess, isError }] = useEstimateApproveMutation();
  const [esRejectUpdate, { isLoading: isLoadingReject, isSuccess: isSuccessReject, isError: isErrorReject }] = useEstimateRejectMutation();

  useEffect(() => {
    setInit({
      ...init,
      apiSkip: false,
    });
  }, []);

  useEffect(() => {
    if (esDetail.isSuccess) {
      setEstimate({
        ...estimate,
        as_idx: esDetail.data.as_idx,
        company_id: esDetail.data.company_id,
        company_name: esDetail.data.company_name,
        total_price: addCommas(esDetail.data.total_price),
        approval_code: esDetail.data.approval_code, //EAC_0 반려,EAC_10 견적대기, EAC_20 견적재요청, EAC_30 승인대기, EAC_100 본사승인
        estimate_goods_list: esDetail.data.estimateGoods,
        cancel_reason: esDetail.data.cancel_reason,
        insert_date: esDetail.data.insert_date,
      });
      setInit({
        ...init,
        asDetailApiSkip: false,
      });
    }
    if (esDetail.isError) {
      const message = ErrorParser(esDetail.error);
      alert(message);
      navigate("/as-list");
    }
  }, [esDetail]);

  // 무상 체크 여부를 위한 asDetail 쿼리 필요
  useEffect(() => {
    if (asDetail.isSuccess) {
      setEstimate({
        ...estimate,
        free_yn: asDetail.data.free_yn,
      });
      setDeleteYn(asDetail.data.delete_yn);
      setFreeYn(asDetail.data.free_yn);
    }
  }, [asDetail]);

  useEffect(() => {
    if (isSuccess) {
      navigate("/as-detail/" + as_idx);
      // location.replace("/as-list");
    }
    if (isError) {
      alert("서버 오류");
    }
    if (isSuccessReject) {
      navigate("/as-detail/" + as_idx);
    }
    if (isErrorReject) {
      alert("서버 오류");
    }
  }, [isLoading, isLoadingReject]);

  // 클릭 함수 영역
  const rejectClick = () => {
    setState({
      ...state,
      isRejectBox: isRejectBox ? false : true,
    });
  };

  // 견적서 승인
  const accessClick = async () => {
    await esApproveUpdate(as_idx);
  };

  // 견적서 반려
  const rejectBtn = async () => {
    if (isEmpty(cancel_reason)) {
      alert("반려사유를 작성해 주세요.");
      return;
    }
    const param = {
      as_idx: as_idx,
      total_price: total_price,
      cancel_reason: cancel_reason,
      company_id: company_id,
      free_yn: freeYn,
    };
    await esRejectUpdate(param);
  };

  const estimateUpdateClick = () => {
    navigate("/estimate-register/" + as_idx);
  };

  const onChange = (e: any) => {
    const { value, id } = e.target;

    setEstimate({
      ...estimate,
      [id]: value,
    });
  };

  const backClick = () => {
    if (!isEmpty(rnData)) {
      navigate("/as-detail/" + as_idx);
    } else {
      navigate(-1);
    }
  };

  const rejectBoxToFunc = (id: string, freeYn: string) => {
    setEstimate({
      ...estimate,
      company_id: id,
      free_yn: freeYn,
    });
    setFreeYn(freeYn);
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => backClick()}>
            견적서
          </Button>
        </div>
      </header>

      <Body type="detail">
        <EstimateWrap>
          {userInfo.user_type === "M" && !isEmpty(cancel_reason) ? <RejectionReason readonly={true} value={cancel_reason} /> : ""}

          <Box pd="50px 45px 75px">
            <TitleBox>
              <p className="title">{company_name}</p>
              <p className="date">{moment(insert_date).format("YYYY.MM.DD HH:mm")}</p>
            </TitleBox>
            <AccordionWrap>
              {estimate_goods_list?.map((v: any, i: number) => {
                return (
                  <Accordion key={i} title={v.goods_name} subTitle={addCommas(v.total_price)}>
                    <DetailItem>
                      <li>
                        <p>단가</p>
                        <p>{addCommas(v.unit_price)}</p>
                      </li>
                      <li>
                        <p>수량</p>
                        <p>{addCommas(v.qty)}</p>
                      </li>
                      <li>
                        <p>사이즈</p>
                        <p>{v.size}</p>
                      </li>
                      <li>
                        <p>단위</p>
                        <p>{v.spec}</p>
                      </li>
                      <li>
                        <p>비고</p>
                        <p>{v.etc}</p>
                      </li>
                    </DetailItem>
                  </Accordion>
                );
              })}
            </AccordionWrap>
            <SummaryBox>
              <p>총 견적금액</p>
              <p>
                <span>{estimate.total_price}</span> 원
              </p>
            </SummaryBox>
          </Box>
          {deleteYn !== "Y" && (
            <>
              {userInfo.user_type === "M" && (approval_code === "EAC_10" || approval_code === "EAC_30" || approval_code === "EAC_20") && (
                <BottomFlex>
                  <ButtonBox>
                    <Button variant="contained" br="round" onClick={() => estimateUpdateClick()}>
                      견적서 수정
                    </Button>
                  </ButtonBox>
                </BottomFlex>
              )}
            </>
          )}
          {userInfo.user_type === "E" ? (
            <>
              <BottomFlex>
                {approval_code === "EAC_30" || approval_code === "EAC_0" ? (
                  <>
                    {!isRejectBox && deleteYn !== "Y" && (
                      <ButtonBox>
                        <Button variant="outlined" br="round" color="secondary" onClick={() => rejectClick()}>
                          반려
                        </Button>
                        <Button variant="contained" br="round" onClick={() => accessClick()}>
                          승인
                        </Button>
                      </ButtonBox>
                    )}
                  </>
                ) : (
                  ""
                )}

                {isRejectBox ? (
                  <>
                    <RejectionBox
                      companyName={company_name}
                      companyId={company_id}
                      onChange={(e: any) => onChange(e)}
                      free_yn={freeYn}
                      rejectBoxToFunc={rejectBoxToFunc}
                      visit_date={asDetail.data.visit_date}
                    />
                    <ButtonBox>
                      <Button variant="contained" br="round" onClick={() => rejectBtn()}>
                        견적 재요청
                      </Button>
                    </ButtonBox>
                  </>
                ) : (
                  ""
                )}
              </BottomFlex>
            </>
          ) : (
            ""
          )}
        </EstimateWrap>
      </Body>
    </>
  );
};

const EstimateWrap = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")}
  height: auto;
  min-height: 100%;
`;

const TitleBox = styled.div`
  margin-bottom: 50px;
  .title {
    font-weight: 700;
    font-size: 18px;
  }
  .date {
    margin-top: 10px;
    color: #818181;
    font-size: 14px;
    font-family: "Poppins";
    font-weight: 400;
  }
`;

const AccordionWrap = styled.div`
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
`;

const DetailItem = styled.ul`
  padding: 5px 0;
  > li {
    ${({ theme }) => theme.flexBox.flexMixin()}
    padding: 8px 0;
    color: #60677d;
    > p:first-child {
      flex-basis: 80px;
    }
    > p:last-child {
      font-family: "Poppins";
      font-weight: 400;
      font-size: 16px;
    }
  }
`;

const SummaryBox = styled.div`
  margin-top: 20px;
  ${({ theme }) => theme.flexBox.flexMixin()}
  > p {
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    &:last-child {
      text-align: right;
      font-family: "Poppins";
      font-weight: 700;
      color: ${({ theme }) => theme.color.subMain};
    }
  }
`;

const BottomFlex = styled.div`
  padding: 55px 45px;
  border-top: 2px dashed #aaa;
  background-color: ${({ theme }) => theme.color.bgPrimary};
`;

const ButtonBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
  > button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export default estimateDetail;
